import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import query from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { BasicTable } from '@synergy/table';
import { Row, Col, Button, Flex, Space, Input, Anchor, Radio, DatePicker, FloatButton, InputNumber, Modal, Divider, notification, ConfigProvider } from 'antd';
import { Text } from '../../Atomics/Text';
import { Widget } from "../../Atomics/Widget";

export const GasConsumption = ({dataToFilter, gasRef, hasGasConsumption, isGasConsumptionLoading}) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [dataGasConsumptionEnergy, setDataGasConsumption] = useState(null);
  //Make calls to obtain data using a custom hook ( useFecth ) and stored in variables. This calls are asynchronous 
  const { data: gasConsumptionData, isLoading: gasConsumptionIsLoading, refetch: refetchGasConsumptionData } =
    useFetch(query.path.detailGasConsumption, 'getDetailGasConsumption', { id: id, filters: JSON.stringify(dataToFilter) });

    useEffect(() => {
      isGasConsumptionLoading(gasConsumptionIsLoading)
    }, [gasConsumptionIsLoading]);

  useEffect(() => {
    if (gasConsumptionData?.data) {
      setDataGasConsumption(gasConsumptionData?.data)
      hasGasConsumption(gasConsumptionData?.data)
    }
  }, [gasConsumptionData?.data]);

  useEffect(() => {
    hasGasConsumption(null)
    refetchGasConsumptionData();
  }, [dataToFilter]);

  return (
    <Flex id='Gas Consumption' className='ant-anchors-content-item' gap={32} vertical="true">
    <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('gasConsumption')}</Text>
    <Row gutter={[16, 16]}>
      <Col span={6}>
        <Flex gap={16} vertical='true'>
          <Widget data={{
            height: '150px',
            background: 'white',
            title: t('gasConsumption'),
            icon: 'Gas',
            charts: [{
              chartType: 'bigNumberChart',
              chartId: 'mixBarChartOne',
              data: dataGasConsumptionEnergy?.gasConsumption
            }]
          }} />
          <Widget data={{
            height: '150px',
            background: 'white',
            title: t('associatedCO2Emissions'),
            icon: 'Emissions',
            charts: [{
              chartType: 'bigNumberChart',
              chartId: 'mixBarChartOne',
              data: dataGasConsumptionEnergy?.associatedEmissions
            }]
          }} />
        </Flex>
      </Col>
      <Col span={18}>
        <div ref={gasRef}>
          <Widget data={{
            height: '316px',
            background: 'white',
            title: t('Gas'),
            icon: 'Gas',
            charts: [{
              chartType: 'columnsChartApex',
              data: dataGasConsumptionEnergy?.gas
            }]
          }} />
        </div>
      </Col>

    </Row>
  </Flex>
  )
}